import { render, staticRenderFns } from "./NvBookGrid.vue?vue&type=template&id=3a33f9b4&scoped=true&"
import script from "./NvBookGrid.vue?vue&type=script&lang=js&"
export * from "./NvBookGrid.vue?vue&type=script&lang=js&"
import style0 from "./NvBookGrid.vue?vue&type=style&index=0&id=3a33f9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a33f9b4",
  null
  
)

export default component.exports